import { ProtoBaseModel, attr, repeated } from '@square/dashboard-data/utils/ember-model-stubs';
export default ProtoBaseModel.extend({
  includeApplicationFields: attr(Boolean),
  includeAttributes: attr(Boolean),
  includeAttachments: attr(Boolean),
  includeBuyerSummary: attr(Boolean),
  includeDeleted: attr(Boolean),
  includeEmailableViaMarketing: attr(Boolean),
  includeEmailSubscriptions: attr(Boolean),
  includeGroups: attr(Boolean),
  includeInstrumentsOnFile: attr(Boolean),
  includeLinkedPaymentCards: attr(Boolean),
  includeReminders: attr(Boolean),
  includeTotalDuplicateCount: attr(Boolean),
  appIds: repeated(String)
});